/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_TermsInputs */

const en_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const ko_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이용약관`)
};

const ja_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Footer_TermsInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const footer_terms = /** @type {((inputs?: Footer_TermsInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_TermsInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_terms(inputs)
	if (locale === "ko") return ko_footer_terms(inputs)
	return ja_footer_terms(inputs)
});